'use client';

import { Header, type HeaderProps } from '@/components/site-header';
import { useNotificationBannerContext } from '@/features/notifications/banner-context';

export type PublicHeaderProps = Omit<HeaderProps, 'notificationBanner' | 'onNotificationBannerClose'>;

/** 通知业务在此接入 Header；共享 Header 不读取 Feature 的 Context。 */
export function PublicHeader(props: PublicHeaderProps) {
    const { notificationBanner, handleBannerClose } = useNotificationBannerContext();
    return <Header {...props} notificationBanner={notificationBanner} onNotificationBannerClose={handleBannerClose} />;
}
